import React, { useState, useEffect } from 'react';
import './InputBox.css'

const convertString2Int = (string) => {
    return parseInt(String(string).replace(/,/g, ''), 10) || 0
}
const convertInt2String = (num) => {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const InputBox = ({ prefix, placeholder, postfix, value, setValue, disabled=false, error=false }) => {
    const [displayValue, setDisplayValue] = useState(convertInt2String(value));
    
    const handleChange = (e) => {
        const inputValue = e.target.value;
        if (/^\d*$/.test(inputValue)) {
            setDisplayValue(inputValue);
        }
    }

    const handleBlur = () => {
        const inputValue = convertString2Int(displayValue);
        setValue(inputValue)
        setDisplayValue(convertInt2String(inputValue))
    }

    const handleFocus = (e) => {
        const inputValue = convertString2Int(displayValue);
        setDisplayValue(inputValue === 0 ? '' : inputValue);
    };
    
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur(); // 엔터 키를 누르면 포커스를 잃도록 처리
        }
    };

    useEffect(() => {
        setDisplayValue(convertInt2String(value));
    }, [value]);

    return(
        <div className="inputBoxContainer">
            {prefix && <span className="inputBoxPrefix">{prefix}</span>}
            <input
                className={`inputBoxInput ${error ? 'error-border' : ''}`}
                type="text"
                placeholder={placeholder}
                value={displayValue}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                onKeyPress={handleKeyPress}
                disabled={disabled}
            />
            {postfix && <span className="inputBoxPrefix">{postfix}</span>}
        </div>
    );
}

export default InputBox;